import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Home } from 'lucide-react';
import BackButton from '@/components/BackButton';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full p-8">
        <div className="text-center">
          <h1 className="text-6xl font-bold text-slate-900 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-slate-700 mb-4">
            Seite nicht gefunden
          </h2>
          <p className="text-slate-600 mb-8">
            Die angeforderte Seite existiert nicht oder wurde verschoben.
          </p>

          <div className="flex justify-center space-x-3">
            <BackButton variant="outline" size="default" />
            <Button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700"
            >
              <Home size={18} />
              <span>Zur Startseite</span>
            </Button>
          </div>

          {/* Debug Info in Dev Mode */}
          {process.env.NODE_ENV === 'development' && (
            <div className="mt-8 p-4 bg-slate-100 rounded text-left text-xs">
              <p className="font-semibold mb-2">Debug Info:</p>
              <p>URL: {window.location.pathname}</p>
              <p>Hash: {window.location.hash}</p>
              <p>Search: {window.location.search}</p>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default NotFoundPage;
